module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#video-play",
      toString: function () {
        return this.url;
      }
    }